import { api } from '../core';
import { MEDICAL_RECORDS_TAG } from '../constants';

export type DocumentUploadCompleteUnassignedResponse = object;

type DocumentUploadCompleteUnassignedProps = {
  documentId: string | null;
  unassignedDocumentId: string | null;
};

const documentUploadCompleteUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentUploadCompleteUnassigned: builder.query<
      DocumentUploadCompleteUnassignedResponse,
      DocumentUploadCompleteUnassignedProps
    >({
      query: ({ documentId, unassignedDocumentId }: DocumentUploadCompleteUnassignedProps) => ({
        url: `document/upload-complete/unassigned`,
        method: 'POST',
        body: {
          documentId: documentId,
          unassignedDocumentId: unassignedDocumentId
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([MEDICAL_RECORDS_TAG]));
        } catch (error) {
          console.error('Error in postDocumentUploadCompleteUnassigned in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentUploadCompleteUnassignedQuery } = documentUploadCompleteUnassignedApi;
